import React from "react";
import S from "./DescriptionEvent.module.scss";

interface IProps {
    id: number;
}

export const DescriptionEventContacts = ({id}: IProps) => {
    return (
        <div className={S.contentDiv}>
            {id === 1 ? (
                <div className={S.content}>
                    <div className={S.title}>Формат мероприятия</div>
                    <div className={S.mainText}>
                        Форум проходит в <span>г. Череповец, во Дворце культуры металлургов:</span> прикладные доклады
                        по двум
                        трекам, демо-день ИЦК «Металлургия», экспертные дискуссии, круглые столы, выставка и вечерний
                        фуршет. Вход для зарегистрированных участников по подтверждению регистрации. Один день —
                        экскурсия на Череповецкий металлургический комбинат.
                    </div>
                    <div className={S.mainText}>
                        Количество участников ограничено — заявки рассматриваются в порядке поступления, места
                        бронируются по мере подтверждения участия.
                    </div>
                    <div className={S.mainText}><span>Присоединяйтесь к тем, кто формирует будущее промышленной цифровизации. Количество мест ограничено.</span>
                    </div>
                </div>
            ) : (
                id === 5 ? (
                    <div className={S.content}>
                        <div className={S.title}>Территория и режим доступа</div>
                        <div className={S.mainText}>
                            Форум проходит на закрытой территории <span>БО «Торово»</span> — это гарантирует безопасность участников и конфиденциальность деловых обсуждений.
                        </div>
                        <div className={S.paragraphText}>
                            <div className={S.mainText}>• <span>Пропускной режим.</span> Доступ на территорию — только
                                по пропускам, оформленным заранее. После подтверждения участия организаторы запросят
                                данные для оформления; вход — по документу, удостоверяющему личность.
                            </div>
                            <div className={S.mainText}>• <span>Закрытая территория.</span> На площадке присутствуют
                                только зарегистрированные участники, докладчики и представители компаний-партнёров.
                                Посторонние не допускаются.
                            </div>
                            <div className={S.mainText}>• <span>Трансфер.</span> Для участников, проживающих за
                                территорией — базы отдыха «Торово», — организован трансфер до места проведения форума и
                                обратно по расписанию деловой программы. График и места посадки будут направлены вместе
                                с подтверждением участия.
                            </div>
                        </div>
                        <div className={S.mainText}><span>Присоединяйтесь к тем, кто формирует будущее промышленного транспорта и логистики. Количество мест ограничено.</span>
                        </div>
                    </div>
                ) : null
            )}
        </div>
    );
};